// Google Sheets API integration using fetch (no additional packages needed)
import { SHEETS_CONFIG } from '../config/sheets';

class GoogleSheetsAPI {
  constructor() {
    this.sheetId = SHEETS_CONFIG.GOOGLE_SHEET_ID;
    this.range = SHEETS_CONFIG.SHEET_RANGE;
  }

  // Fetch data from Google Sheets using CSV export (requires public access)
  async fetchSheetData() {
    try {
      console.log('🔍 Fetching data from Google Sheet ID:', this.sheetId);
      
      // Method: Use Google Sheets CSV export (requires sheet to be publicly readable)
      const publicUrl = `https://docs.google.com/spreadsheets/d/${this.sheetId}/export?format=csv&gid=0`;
      
      console.log('📡 CSV Export URL:', publicUrl);
      
      const response = await fetch(publicUrl);
      console.log('📊 Response status:', response.status, response.statusText);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const csvText = await response.text();
      console.log('📄 Raw CSV data:', csvText);
      
      return this.parseCSV(csvText);
      
    } catch (error) {
      console.error('❌ Error fetching sheet data:', error);
      throw error;
    }
  }

  // Parse CSV data into notification objects
  parseCSV(csvText) {
    const lines = csvText.split('\n').filter(line => line.trim());
    if (lines.length === 0) {
      console.log('⚠️ No data lines found in CSV');
      return [];
    }
    
    const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
    console.log('📋 Headers found:', headers);
    
    const notifications = [];
    
    for (let i = 1; i < lines.length; i++) {
      const values = lines[i].split(',').map(v => v.trim().replace(/"/g, ''));
      
      if (values.length >= headers.length && values[0]) { // Skip empty rows
        const notification = {};
        
        headers.forEach((header, index) => {
          notification[header.toLowerCase()] = values[index] || '';
        });
        
        console.log('📝 Parsed notification:', notification);
        notifications.push(notification);
      }
    }
    
    console.log('✅ Total notifications parsed:', notifications.length);
    return notifications;
  }

  // Get active notifications
  async getActiveNotifications() {
    try {
      console.log('🚀 Starting to fetch active notifications...');
      const notifications = await this.fetchSheetData();
      
      const activeNotifications = notifications.filter(notification => {
        console.log('🔍 Checking notification:', notification);
        
        // Check if notification is active
        const isActive = notification.active?.toLowerCase() === 'true';
        console.log('✅ Is active:', isActive, 'Value:', notification.active);
        
        if (!isActive) {
          console.log('❌ Skipping inactive notification');
          return false;
        }
        
        const now = new Date();
        const scheduledDate = new Date(notification.scheduleddate);
        
        console.log('⏰ Time check:', {
          now: now.toISOString(),
          scheduledDate: scheduledDate.toISOString(),
          show24HoursBefore: notification.show24hoursbefore
        });
        
        // Check if notification should be shown based on show24hoursbefore setting
        if (notification.show24hoursbefore?.toLowerCase() === 'true') {
          const twentyFourHoursBefore = new Date(scheduledDate.getTime() - 24 * 60 * 60 * 1000);
          const shouldShow = now >= twentyFourHoursBefore;
          console.log('🕐 24h before check:', { 
            twentyFourHoursBefore: twentyFourHoursBefore.toISOString(), 
            shouldShow 
          });
          return shouldShow;
        } else {
          // Show only after scheduled date
          const shouldShow = now >= scheduledDate;
          console.log('📅 After date check:', { shouldShow });
          return shouldShow;
        }
      });
      
      console.log('🎯 Active notifications found:', activeNotifications.length, activeNotifications);
      return activeNotifications;
      
    } catch (error) {
      console.error('❌ Error getting active notifications:', error);
      return [];
    }
  }
}

export default new GoogleSheetsAPI();
